import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faRotateLeft, faXmark } from '@fortawesome/free-solid-svg-icons';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorService } from '../../../../../../../@core/utils/error.service';
import { TransactionService } from '../../../../../../core/services/TransactionService';
import { HandlingUnitDetailDTO } from '../../../../models/handling-unit-detail';

export interface RestoreItemData {
  details: HandlingUnitDetailDTO[];
}

export interface RestoreItemResult {
  detailId: number;
  transactionReasonCodeId: number;
}

@Component({
  selector: 'restore-item-popup',
  templateUrl: './restore-item-popup.component.html',
  styleUrls: ['./restore-item-popup.component.scss']
})
export class RestoreItemPopupComponent implements OnInit {

  private destroyRef = inject(DestroyRef);

  static open(dialog: MatDialog, data: RestoreItemData): MatDialogRef<RestoreItemPopupComponent, RestoreItemResult | null> {
    return dialog.open(RestoreItemPopupComponent, { data, width: '520px', maxWidth: '95vw' });
  }

  public faXmark = faXmark;
  public faRotateLeft = faRotateLeft;

  public details: HandlingUnitDetailDTO[] = [];
  public transactionReasons = [];
  public isLoading = true;
  public selectedDetailId: number;
  public transactionReasonCodeId = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RestoreItemData,
    private dialog: MatDialogRef<RestoreItemPopupComponent, RestoreItemResult | null>,
    private transactionService: TransactionService,
    private errorService: ErrorService
  ) { }

  ngOnInit() {
    this.details = this.data?.details ?? [];

    if (this.details.length == 1)
      this.selectedDetailId = this.details[0].id;

    this.transactionService.getTransactionReasonCodes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next: x => {
      this.transactionReasons = x;
      this.isLoading = false;
    }, error: err => {
      this.errorService.handleError(err);
      this.isLoading = false;
    }});
  }

  trackByDetail(_: number, detail: HandlingUnitDetailDTO): number | undefined {
    return detail.id;
  }

  close(restore: boolean) {
    this.dialog.close(restore ? {
      detailId: this.selectedDetailId,
      transactionReasonCodeId: this.transactionReasonCodeId
    } : null);
  }

}
